import Wrapper from "../assets/wrappers/Services";
import services from "../assets/images/services.png";
const Services = () => {
  return (
    <Wrapper name="services">
      <div className="container">
        <div className="left" data-aos="zoom-in">
          <img className="image" src={services} alt="Physical therapy services illustration showing manual therapy, sports rehabilitation, and pain management" />
        </div>

        <div className="right">
          <h3>Our Services</h3>
          <div className="list-container">
            <div className="item" data-aos="fade-left">
              <div className="number">1</div>
              <div className="content">
                <h4>Manual Therapy</h4>
                <p>
                  Hands-on techniques to mobilize joints and soft tissues for pain relief and improved movement.
                </p>
              </div>
            </div>
            <div className="item" data-aos="fade-left">
              <div className="number">2</div>
              <div className="content">
                <h4>Sports Injury Rehabilitation</h4>
                <p>Specialized programs to help athletes recover quickly and prevent future injuries.</p>
              </div>
            </div>
            <div className="item" data-aos="fade-left">
              <div className="number">3</div>
              <div className="content">
                <h4>Post-Surgical Rehab</h4>
                <p>
                  Comprehensive care following orthopedic surgeries to restore strength and function.
                </p>
              </div>
            </div>
            <div className="item" data-aos="fade-left">
              <div className="number">4</div>
              <div className="content">
                <h4>Chronic Pain Management</h4>
                <p>
                  Evidence-based strategies to manage and reduce long-standing pain conditions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Services;
